/**
 * Distinguishes a user pressing "Sign out" from the session ending on its
 * own. Both surface as the same Supabase SIGNED_OUT event, but only the latter
 * should tell the user "your session expired". Set by the logout thunk right
 * before it signs out; consumed (and reset) by App.tsx's SIGNED_OUT handler.
 */
let userInitiatedSignOut = false;

export function markUserInitiatedSignOut(): void {
  userInitiatedSignOut = true;
}

export function consumeUserInitiatedSignOut(): boolean {
  const wasUserInitiated = userInitiatedSignOut;
  userInitiatedSignOut = false;
  return wasUserInitiated;
}
